import React, { useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import BackgroundCheckList from './BackgroundCheckList';
import { Link } from 'react-router-dom';

const BackgroundCheck = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  return (
    <>
      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div className="header header-bg-lender pt-3">
              <div className="col-lg-6 col-7">
                <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4" style={{ marginLeft: '30px' }}>
                  <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                    <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                    <li className="breadcrumb-item mt-2"><span style={{ color: "#f6f9fc" }}>Background Checks</span></li>
                  </ol>
                </nav>
              </div>
            </div>

            <div className='conatiner-fluid tab-component'>
              <BackgroundCheckList />
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default BackgroundCheck;
